module.exports = __webpack_public_path__ + "static/media/product_list.82b6463b.png";